module.exports = __webpack_public_path__ + "static/media/Latanya B.1e12847e.jpeg";